
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'FCSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    displayPlaceHolder: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '-- Please select a size --',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
});
